import { AuthService } from './services';
import { authorizedState, loginState, logoutState, unauthorizedState } from './auth.states';
import { loadNg1Module, ngmodule } from "../bootstrap/ngmodule";
import { login } from './login';
import { logout } from './logout';
import { authorized } from './authorized';
import { unauthorized } from './unauthorized';
import { authHookRunBlock } from './services/auth.hook';

const authorizationAppModule: aboTheme.INgModule = {
  components: {login, logout, authorized, unauthorized},
  states: [loginState, logoutState, authorizedState, unauthorizedState],
  services: { AuthService },
  runBlocks: [authHookRunBlock]
};

loadNg1Module(ngmodule, authorizationAppModule);


// WEBPACK FOOTER //
// ./src/app/authorization/index.ts